import { createHttpInstance } from '~/common/utils/http';

const httpInstance = createHttpInstance('courier');

export default httpInstance;
